// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ToggleButtonGroupTsx from "./ToggleButtonGroup.tsx";

let make = ToggleButtonGroupTsx.ToggleButtonGroup;

function findValueByKey(items, key) {
  return Stdlib_Option.map(items.find(item => item.key === key), param => param.value);
}

function ToggleButtonGroup(props) {
  let onChange = props.onChange;
  let value = props.value;
  let items = props.items;
  let selectionMode;
  selectionMode = typeof value !== "object" || value.TAG === "Single" ? "single" : "multiple";
  let values;
  values = typeof value !== "object" ? [] : (
      value.TAG === "Single" ? [value._0] : value._0
    );
  let selectedKeys = Stdlib_Array.filterMap(values, value => Stdlib_Option.map(items.find(item => Primitive_object.equal(item.value, value)), param => param.key));
  let onSelectionChange = keys => {
    if (typeof value === "object" && value.TAG !== "Single") {
      return onChange({
        TAG: "Multiple",
        _0: Stdlib_Array.filterMap(keys, key => findValueByKey(items, key))
      });
    }
    let value$1 = Stdlib_Option.flatMap(keys[0], key => findValueByKey(items, key));
    if (value$1 !== undefined) {
      return onChange({
        TAG: "Single",
        _0: Primitive_option.valFromOption(value$1)
      });
    } else {
      return onChange("Empty");
    }
  };
  let flatItems = items.map(param => ({
    value: param.key,
    label: param.label,
    icon: param.icon,
    endElement: param.endElement,
    disabled: param.disabled
  }));
  return JsxRuntime.jsx(make, {
    ariaLabel: props.ariaLabel,
    label: props.label,
    tooltip: props.tooltip,
    errorMessage: props.errorMessage,
    required: props.required,
    size: props.size,
    grow: props.grow,
    attached: props.attached,
    disallowEmptySelection: props.disallowEmptySelection,
    selectionMode: selectionMode,
    items: flatItems,
    value: selectedKeys,
    onChange: onSelectionChange
  });
}

let make$1 = ToggleButtonGroup;

export {
  make$1 as make,
}
/* make Not a pure module */
